import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {service} from "./service/service";
import * as serviceWorker from "./serviceWorkerRegistration";

service()
serviceWorker.register();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
